import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Grid, Col, Row } from 'react-bootstrap';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import PrizeForm from './prize-form';
import { getPrize, getPrizeMeta, getPrizeOutletIncentives } from '../../../../actions/prizes';

class PrizeFormPage extends Component {
  componentWillMount() {
    this.props.dispatch(actions.reset('deep.prize'));
    this.id = +this.props.match.params.id;
    this.edit = !isNaN(this.id);
    this.props.dispatch(getPrizeMeta());

    if (this.edit) {
      this.props.dispatch(getPrize(this.id)).then(() => {
        this.props.dispatch(getPrizeOutletIncentives(this.props.prize.attributes['outlet-id']));
        this.props.dispatch(actions.resetValidity('deep.prize'));
      })
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.prize'));
  }

  render() {
    return (
      <Grid bsClass="container" fluid className="prizes">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/prizes" />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Add Prize</PageTitle>
            <PrizeForm />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    prize: state.prizes.prize || {}
  }
}

export default connect(mapStateToProps)(PrizeFormPage);



// WEBPACK FOOTER //
// ./src/components/admin/prizes/edit/prize-form-page.js